import { Breadcrumb, Select, Input, InputNumber } from "antd";
import { t } from "i18next";
import { BackIcon } from "../../../../asset";
import React, { useState } from 'react';
import style from './palletPage.module.css'
import ConfirmationModal from "../../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useLocation, useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import { usePallet } from "./PalletPage.hooks";
import { useEffect } from "react";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";

export default function PalletEdit() {

    const { state } = useLocation();

    const {
        successModalOpen,
        setSuccessModalOpen,
        toListPallet,
        doEditPallet,
        onChange,
        setEditedData,
        isEdited,
        setShowConfirm,
        showConfirm,
        palletNameError,
        palletDescriptionError,
        palletWeightError
    } = usePallet()

    useEffect(() => {
        setEditedData(state.data)
    }, [])


    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <ModalConfirmLeave
                visible={showConfirm}
                action={() => setShowConfirm(false)}
                route={ROUTES.PALLET.LIST}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => toListPallet()}
                closable={false}
                width={280}
                className={style.successModal}
                okText="Ok"
                title="Success"
                description="Your data has been updated"
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Pallet`}
                menuLevel4={`Edit ${state.data.pallet_id} - ${state.data.pallet_name}`}
            />

            <div className="flex items-center gap-[22px] cursor-pointer" onClick={isEdited() ? () => setShowConfirm(true) : () => toListPallet()}>
                <img src={BackIcon} alt="back-icon" />
                <h1 className='font-sans-bold text-2xl' id='title'>{`${t("PALLET_EDIT:TITLE")} ${state.data.pallet_id} - ${state.data.pallet_name}`}</h1>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px] flex gap-[200px]">
                <div>
                    <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("PALLET_EDIT:PALLET_INFORMATION")}</h3>

                    <div className="flex flex-col gap-[16px]">
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:PALLET_ID_FIELD")}</label>
                            <Input style={{ width: 350 }} className='mt-[8px]' disabled defaultValue={state.data.pallet_id} />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:PALLET_NAME_FIELD")}</label>
                            <Input style={{ width: 350 }} className='mt-[8px]' onChange={(event) => onChange(event, 'pallet_name')} defaultValue={state.data.pallet_name} placeholder={t("PALLET_EDIT:PALLET_NAME_PLACEHOLDER")} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletNameError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:DESCRIPTION_PALLET_FIELD")}</label>
                            <TextArea
                                style={{ width: 350, resize: 'none' }}
                                placeholder={t("PALLET_EDIT:DESCRIPTION_PALLET_PLACEHOLDER")}
                                defaultValue={state.data.description}
                                onChange={(event) => onChange(event, 'pallet_description')}
                            />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletDescriptionError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                    </div>
                </div>
                <div>
                    <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("PALLET_EDIT:PALLET_SPECIFICATION")}</h3>

                    <div className="flex flex-col gap-[16px]">
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:WEIGHT_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' placeholder='0' onChange={(event) => onChange(event, 'weight')} defaultValue={state.data.weight} addonAfter={<div className='text-[#818181]'>Kg</div>} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletWeightError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:LENGHT_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' placeholder='0' onChange={(event) => onChange(event, 'length')} defaultValue={state.data.length} addonAfter={<div className='text-[#818181]'>M</div>} />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:HEIGHT_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' placeholder='0' onChange={(event) => onChange(event, 'height')} defaultValue={state.data.height} addonAfter={<div className='text-[#818181]'>M</div>} />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_EDIT:WIDTH_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' placeholder='0' onChange={(event) => onChange(event, 'width')} defaultValue={state.data.width} addonAfter={<div className='text-[#818181]'>M</div>} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={() => doEditPallet(state.data)}>
                    {t("PALLET_EDIT:SAVE_BUTTON")}
                </button>
                <button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={isEdited() ? () => setShowConfirm(true) : () => toListPallet()}>
                    {t("PALLET_EDIT:CANCEL_BUTTON")}
                </button>
            </div>

        </div>
    )
}